import { Moon, Sun } from "lucide-react";
import { useTheme } from "../../context/themeContext";

const ThemeToggle = ({ className = "" }) => {
  const { isDark, toggleTheme } = useTheme();
  return (
    <button
      onClick={toggleTheme}
      aria-label="Toggle theme"
      className={`relative flex h-8 w-[58px] shrink-0 items-center rounded-full border px-1
        border-black/10 dark:border-white/10 bg-black/[0.04] dark:bg-white/[0.06]
        transition-colors duration-300 ${className}`}
    >
      <Moon size={12} className={`absolute left-1.5 transition-colors ${isDark ? "text-[#C9C0FF]" : "text-slate-400"}`} />
      <Sun size={12} className={`absolute right-1.5 transition-colors ${!isDark ? "text-[#F5B14C]" : "text-slate-400"}`} />
      <span
        className={`z-10 flex h-6 w-6 items-center justify-center rounded-full bg-gradient-to-br shadow-md
          transition-transform duration-300 ease-out
          ${isDark ? "translate-x-0 from-[#4c3fbd] to-[#8C7CF0]" : "translate-x-[26px] from-[#fbbf24] to-[#F5B14C]"}`}
      >
        {isDark ? <Moon size={11} className="text-white" /> : <Sun size={11} className="text-white" />}
      </span>
    </button>
  );
};

export default ThemeToggle;